import If from 'global/ErrorHandlers/If';
import styled from 'styled-components';

interface LoaderBarProps {
  isLoading?: boolean;
}

const LoaderBarDiv = styled.div`
  @keyframes loading {
    from {
      left: -200px;
      width: 30%;
    }
    50% {
      width: 30%;
    }
    70% {
      width: 70%;
    }
    80% {
      left: 50%;
    }
    95% {
      left: 120%;
    }
    to {
      left: 100%;
    }
  }

  height: 1px;
  width: 100%;
  position: relative;
  overflow: hidden;
  background-color: #dadada;
  border-radius: 2px 2px 0 0;
  margin-top: 0;
  transition: 0.3s ease all;

  :before {
    display: block;
    position: absolute;
    content: '';
    left: -200px;
    width: 200px;
    height: 1px;
    background-color: #00ab6b;
    animation: loading 2s linear infinite;
  }
`;

const LoaderBar = ({ isLoading = true }: LoaderBarProps) => {
  return (
    <If condition={isLoading}>
      <LoaderBarDiv />
    </If>
  );
};

export default LoaderBar;
